<template>
    <div class="story-maker-sticker story-maker-sticker-survey" :class="{edit: isEditing}" @click="finish">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')" @click="changeColor">
        <!-- <p class="text-finish" @click="finish">Terminé</p> -->
        <div class="sticker sticker-survey" 
            :style="{ 
                top: `${$attrs.position.y}%`, 
                left: `${$attrs.position.x}%`,
                transform: isCover || isPreventCover ? `translate(-50%, -50%) scale(${$attrs.transform.scale}) rotate(${$attrs.transform.rotate}deg)` : ''
            }"
        >
            <div 
                class="survey-header"
                v-if="isEditing || models.question"
                :style="{ 
                    backgroundColor: models.color
                }"
            >
                    <textarea @input="resize" :value="models.question" ref="textarea_question" modelPath="question" cols="20" rows="2" wrap="hard" maxlength="100" :placeholder="$t('dash.post-creator.story.survey-question')" :readonly="!isEditing"></textarea>
            </div>
            <div class="choises">
                <div class="choise" v-for="(_,index) in Array.from({ length:4})" v-if="(isEditing || models.responses[index]) && (index < 3 || (models.responses[2] || models.responses[3]))" :class="{optional: index >= 2 && !models.responses[index]}">
                    <textarea 
                        v-if="isEditing"
                        cols="20" 
                        rows="2" 
                        wrap="hard" 
                        maxlength="100" 
                        :placeholder="[$t('dash.post-creator.story.survey-yes'), $t('dash.post-creator.story.survey-no'), $t('dash.post-creator.story.survey-add-option'), $t('dash.post-creator.story.survey-add-option')][index]"
                        @input="resize" 
                        :value="models.responses[index] ? models.responses[index] : ''" 
                        :modelPath="`responses.${index}`"
                        ref="textarea_choice"
                        >
                    </textarea>

                    <textarea 
                        v-else
                        cols="20" 
                        rows="2" 
                        wrap="hard" 
                        maxlength="100" 
                        :placeholder="[$t('dash.post-creator.story.survey-yes'), $t('dash.post-creator.story.survey-no'), $t('dash.post-creator.story.survey-add-option'), $t('dash.post-creator.story.survey-add-option')][index]"
                        v-model="models.responses[index]"
                        :readonly="true"
                        @mousedown.prevent
                        @selectstart.prevent
                        :modelPath="`responses.${index}`"
                        ref="textarea_choice"
                        >
                    </textarea>
                </div>
            </div>
        </div>
     
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';

    const colorsHeader = ["#0C0F14", "#ff0067", "#e600ca", "#7f33ff", "#ff6f00", "#00d455", "#0097fd"]
    export default {
        props: {
            id: Number | String,
            isEditing: Boolean,
            question: String,
            responses: Array,
            color: String,
            isPreventCover: Boolean,
            isCover: Boolean,
            setCover: Function,
            setCbClick: Function,
        },

        data() {
            return {
                timeoutFinish: null,
                models : {
                    question: "",
                    responses: [],
                    color:''
                }
            }
        },

        mounted () {
            if (this.setCbClick) this.setCbClick(this.clickSticker);
            EventBus.$on('storyMaker-confirmEditingSticker', this.saveCurrentState);

             this.$nextTick(()=> {

                if(this.isEditing && typeof this.focusAtEnd === 'function') this.focusAtEnd()

                this.resize({target: this.$refs[`textarea_question`]})
                this.$refs[`textarea_choice`].forEach(textarea => {
                    this.resize({target: textarea})
                });
               

            })
        },
 

        methods: {
            clickSticker() {
                if (this.isEditing) return 
                this.setCover(true)
                this.$nextTick(()=> {
                    this.$emit('updateSticker',this.id , {
                        isEditing: true
                    })   
                })
            },

            saveCurrentState() {
                if (!this.isEditing) return;
                const resDefaults = [this.$t('dash.post-creator.story.survey-yes'), this.$t('dash.post-creator.story.survey-no')];
                this.$emit('updateSticker', this.id, {
                    isEditing: false,
                    data: {
                        question: this.models.question,
                        responses: this.models.responses.reduce((acc, res, index) => {
                            if (index < 4 && (res || resDefaults[index])) acc.push(res || resDefaults[index]);
                            return acc;
                        }, []),
                        color: this.models.color
                    },
                });
                if (this.timeoutFinish) clearTimeout(this.timeoutFinish);
                this.timeoutFinish = setTimeout(() => { this.setCover(false); }, 200);
            },

            finish(event) {
                if (this.isCover && event.target.classList.contains('story-maker-sticker') || event.target.classList.contains('text-finish')) {
                    this.saveCurrentState();
                }
            },

            changeColor() {
                const index = colorsHeader.findIndex((color)=> color == this.models.color)
                this.models.color = colorsHeader[(index+1)%colorsHeader.length]                
            },

            resize(e) {
                const maxLine = 2
                let element = e.target;
                if (!element) return
                console.log("resize", element.value, element.getAttribute('modelPath'))
                const modelPath = element.getAttribute('modelPath').split('.')
                const modelname = modelPath.pop();
                const modelObject = modelPath.reduce((acc, k) => acc[k], this.models);
                console.log("resize", modelname, modelObject, element)

                if (!modelname) return

                const lineHeight =  parseFloat(getComputedStyle(element).lineHeight);

                element.style.height = `${lineHeight}px`;
                const scrollHeight = element.scrollHeight;
             
                if (scrollHeight >= lineHeight*(maxLine+1)) {
                    element.style.height = `${lineHeight * maxLine}px`;
                    element.value = modelObject[modelname]
                }else{
                    this.$set(modelObject, modelname, element.value)
                    // modelObject[modelname] = element.value;
                    element.style.height = Math.min(scrollHeight,lineHeight * maxLine) + "px";
                }
            },
        },

        beforeDestroy() {
            EventBus.$off('storyMaker-confirmEditingSticker', this.saveCurrentState);
        },

        watch: {
            question: {
                handler(newValue) {
                    this.models.question = newValue
                },
                immediate: true
            },
            responses: {
                handler(newValue) {
                    this.models.responses = newValue
                },
                immediate: true
            },
            color: {
                handler(newValue) {
                    this.models.color = newValue
                },
                immediate: true
            },
            isEditing: {
                handler(newValue) {
                    if (newValue && !this.isPreventCover && !this.isCover) {
                    this.isEditing = false
                    this.clickSticker()
                }
                },
                immediate: true
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>
<!-- https://vuejs.org/guide/built-ins/transition-group -->